import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { Image, Label } from 'semantic-ui-react';
import IconButton from 'material-ui/IconButton';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Visibility from 'material-ui-icons/Visibility';
import VisibilityOff from 'material-ui-icons/VisibilityOff';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';

import classNames from 'classnames/bind';
import styles from './ReduxFormCommon.css';
const cx = classNames.bind(styles);

class renderField extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false
    };
  }

  componentDidMount() {
    const { input, defaultValue } = this.props;

    if (typeof defaultValue !== 'undefined' && (typeof input.value === 'undefined' || input.value === '')) {
      input.onChange(defaultValue);
    }
  }

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPasssword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const {
      input,
      meta,
      checkType,
      className,
      InputClassName,
      defaultValue,
      noerror,
      validate,
      warnning,
      refPass,
      helperText,
      userCheck,
      errorText,
      serviceCheck,
      ...rest
    } = this.props;

    if (!noerror && (meta.dirty || meta.touched) && meta.visited && meta.error) {
      rest.error = true;
    }

    let message = null;
    if (rest.error) {
      if (userCheck) {
        message = userCheck;
      } else if (errorText) {
        message = errorText;
      } else if (serviceCheck) {
        message = serviceCheck;
      } else {
        message = meta.error;
      }
    }

    return (
      <FormControl
        className={cx(
          'field-textfield-material',
          className,
          !!warnning && 'warnning',
          checkType === 99 ? 'flex-row' : ''
        )}
        error={rest.error || false}
        fullWidth={rest.fullWidth}>
        <InputLabel error={rest.error || false} htmlFor={input.name} required={rest.required || false}>
          {rest.label}
        </InputLabel>
        <Input
          id={input.name}
          className={cx(InputClassName ? InputClassName : '', rest.error ? 'validate-error' : '')}
          {...input}
          ref={refPass}
          {...rest}
          type={this.state.showPassword ? 'text' : rest.type}
          endAdornment={
            rest.type === 'password' ? (
              <InputAdornment position="end">
                <IconButton
                  onClick={this.handleClickShowPasssword}
                  onMouseDown={this.handleMouseDownPassword}
                  // endAdornment blur 시 값이 날아가는 것 방지
                  onBlur={e => {
                    e.stopPropagation();
                  }}>
                  {this.state.showPassword ? (
                    <Image src={'/img/modal/pass_on.png'} />
                  ) : (
                    <Image src={'/img/modal/pass_off.png'} />
                  )}
                </IconButton>
              </InputAdornment>
            ) : null
          }
        />
        {rest.error ? (
          <Label className={cx('pointing-label')} basic pointing>
            {message}
          </Label>
        ) : null}
        {/* {rest.error || userCheck ? (
          <Label className={cx('pointing-label')} basic pointing>
            {meta.error}
          </Label>
        ) : null} */}
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
        {/* <ReduxFormFieldCheckPopup checkType={checkType} {...meta} /> */}
      </FormControl>
    );
  }
}

const ReduxFormMaterialTextField = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormMaterialTextField.propTypes = {
  checkType: PropTypes.number
};
ReduxFormMaterialTextField.defaultProps = {
  checkType: 99
};

export default ReduxFormMaterialTextField;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormMaterialTextField.js